import React, { Component } from 'react';
import MoneyComponent from '../elements/MoneyComponent';
import Category from '../../models/Category';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import SpendSummaryItem from '../components/SpendSummaryItem';
import CategoryNameComponent from '../components/CategoryNameComponent';
import SummaryCategoryItem from '../components/summary/SummaryCategoryItem';
import SummaryCategoryItems from '../components/summary/SummaryCategoryItems';
import Button from "../components/Button";

class MonthlySummaryGeneral extends Component {
	constructor(props) {
		super(props);
		this.categorySort = this.categorySort.bind(this);

		this.state = {
			activeSummaryView: null
		};

		this.resetSummaryView = this.setSummaryView.bind(this, null);
		this.incomeClick = this.setSummaryView.bind(this, 'income');
		this.spentClick = this.setSummaryView.bind(this, 'spent');
		this.budgetedClick = this.setSummaryView.bind(this, 'budgeted');
		this.savedClick = this.setSummaryView.bind(this, 'saved');
		this.debtClick = this.setSummaryView.bind(this, 'debt');
	}

	setSummaryView(view) {
		this.setState({
			activeSummaryView: this.state.activeSummaryView === view ? null : view
		});
	}

	displayBudgetAmountFunded(budget) {
		return budget.getFundTotal();
	}

	displayBudgetAmountBudgeted(budget) {
		return budget.getBudgeted();
	}

	displayBudgetAmountSpent(budget) {
		return budget.getSpent();
	}

	categorySort(a, b) {
		const { selectedDates } = this.props;
		return a.getMultiBudget(selectedDates).getSpent() > b.getMultiBudget(selectedDates).getSpent() ? -1 : 1;
	}

	render() {
		const { selectedDates, transactions, categories, categoryGroups } = this.props;
		const { activeSummaryView } = this.state;

		if(!transactions || !categories || !categoryGroups) {
			return null;
		}

		const categoriesSorted = Array.from(categories).map(([id, category]) => {
			return category;
		});
		const unknownCategory = new Category({});
		unknownCategory.name = 'Unknown';
		unknownCategory.setTransactionFinder(transactionFinder);
		categoriesSorted.push(unknownCategory);
		categoriesSorted.sort(this.categorySort);

		let usedCategories = null;
		if(activeSummaryView === 'budgeted') {
			usedCategories = categoriesSorted
				.filter((category) => {
					return category.getMultiBudget(selectedDates).getBudgeted() > 0;
				})
				.sort((a, b) => {
					const aBudgeted = a.getMultiBudget(selectedDates).getBudgeted();
					const bBudgeted = b.getMultiBudget(selectedDates).getBudgeted();
					if(aBudgeted === bBudgeted) {
						return 0;
					}
					return aBudgeted > bBudgeted ? -1 : 1;
				});

		}

		const notUsedCategories = categoriesSorted.filter((category) => {
			return category.getMultiBudget(selectedDates).getSpent() <= 0;
		});

		const { totalSpent, totalMade, totalSaved, totalSpentOnLoans, totalBudgeted, totalDebt } = Category.getSummaryTotals(categories, categoryGroups, selectedDates);


		const totalIncomeAvailableToSpend = totalMade - totalSaved;

		const loanCategories = categoriesSorted
			.filter((category) => {
				return category.isLoanCategory(categoryGroups.get(category.category_group_id));
			});

		const incomeCategories = categoriesSorted
			.filter((category) => {
				const categoryGroup = categoryGroups.get(category.category_group_id);
				return categoryGroup?.type === Category.types.INCOME;
			});

		const saveCategories = categoriesSorted.filter((category) => {
			const categoryGroup = categoryGroups.get(category.category_group_id);
			return categoryGroup?.type === Category.types.SAVINGS;
		});
		const spendCategories = categoriesSorted
			.filter((category) => {
				const categoryGroup = categoryGroups.get(category.category_group_id);
				return categoryGroup?.type === Category.types.EXPENSE ||
					categoryGroup?.type === null ||
					category === unknownCategory;
			})
			.filter((category) => {
				if(category === unknownCategory){
					console.log('my spent!', category.getMultiBudget(selectedDates).getSpent());
				}
				return category.getMultiBudget(selectedDates).getSpent() > 0;
			})
			.sort((a, b) => {
				const aBudgeted = a.getMultiBudget(selectedDates).getSpent();
				const bBudgeted = b.getMultiBudget(selectedDates).getSpent();
				if(aBudgeted === bBudgeted) {
					return 0;
				}
				return aBudgeted > bBudgeted ? -1 : 1;
			});


		return (
			<div className='spend_summary'>
				<div className='row'>
					<div className='col s12 m6 l6'>
						{(activeSummaryView === null || activeSummaryView === 'income' || activeSummaryView === 'spent') &&
						<div className='spend_summary collection'>
							{(activeSummaryView === null || activeSummaryView === 'income') &&
							<SpendSummaryItem
								onClick={this.incomeClick}
								icon='flash_on'
								color='positive'
								title='Income'
								money={<MoneyComponent amount={totalMade} />}
							/>
							}
							{(activeSummaryView === null || activeSummaryView === 'spent') &&
							<SpendSummaryItem
								onClick={this.spentClick}
								icon='flash_on'
								color='positive'
								title='Spent'
								money={<MoneyComponent amount={totalSpent} />}
							/>
							}
							{false &&
							<SpendSummaryItem
								icon='flash_on'
								color='positive'
								title='Income Minus Savings'
								money={<MoneyComponent amount={totalIncomeAvailableToSpend} />}
							/>
							}
						</div>
						}
						{(activeSummaryView === null || activeSummaryView === 'budgeted' || activeSummaryView === 'saved') &&
						<div className='spend_summary collection'>
							{(activeSummaryView === null || activeSummaryView === 'budgeted') &&
							<SpendSummaryItem
								onClick={this.budgetedClick}
								icon='favorite'
								color='neutral'
								title='Budgeted'
								money={<MoneyComponent
									amount={totalBudgeted}
								/>}
							/>
							}
							{(activeSummaryView === null || activeSummaryView === 'saved') &&
							<SpendSummaryItem
								onClick={this.savedClick}
								icon='favorite'
								color='neutral'
								title='Saved'
								money={<MoneyComponent amount={totalSaved} />}
							/>
							}
						</div>
						}
						{(activeSummaryView === null || activeSummaryView === 'debt') &&
						<div className='spend_summary collection'>
							<SpendSummaryItem
								onClick={this.debtClick}
								icon='pan_tool'
								color='negative'
								title='Total Loans'
								money={<MoneyComponent showNegative amount={totalDebt} />}
							/>
						</div>
						}
						{!!activeSummaryView &&
						<div>
							<Button
								onClick={this.resetSummaryView}
							>
								Back
							</Button>
						</div>
						}
					</div>
					<div className='col s12 m6 l6'>
						{activeSummaryView === 'budgeted' &&
						<SummaryCategoryItems
							categories={usedCategories}
							selectedDates={selectedDates}
							amountDisplayed={this.displayBudgetAmountBudgeted}
							totalToShowPercentageOf={totalBudgeted}
						/>
						}
						{activeSummaryView === 'debt' &&
						<SummaryCategoryItems
							categories={loanCategories}
							selectedDates={selectedDates}
							amountDisplayed={this.displayBudgetAmountFunded}
						/>
						}
						{activeSummaryView === 'spent' &&
						<SummaryCategoryItems
							categories={spendCategories}
							selectedDates={selectedDates}
							amountDisplayed={this.displayBudgetAmountSpent}
							totalToShowPercentageOf={totalSpent}
						/>
						}
						{activeSummaryView === 'saved' &&
						<SummaryCategoryItems
							categories={saveCategories}
							selectedDates={selectedDates}
							amountDisplayed={this.displayBudgetAmountSpent}
						/>
						}
						{activeSummaryView === 'income' &&
						<SummaryCategoryItems
							categories={incomeCategories}
							selectedDates={selectedDates}
							amountDisplayed={this.displayBudgetAmountSpent}
						/>
						}
						{false &&
						<React.Fragment>
							<div className='collection'>
								{notUsedCategories.map((category) => {
									return <SummaryCategoryItem
										key={category.id}
										category={category}
										selectedDates={selectedDates}
										amountDisplayed={this.displayBudgetAmountSpent}
									/>;
								})}
							</div>
						</React.Fragment>
						}
					</div>

				</div>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		...state.dashboard,
	};
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators({}, dispatch);
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(MonthlySummaryGeneral);